// extracted by mini-css-extract-plugin
module.exports = {"fileBox":"File_fileBox__8oNMT","success":"File_success__SeHbi"};